
document.addEventListener('DOMContentLoaded' , () =>{
	//header gnb
	const body = document.body,
		  gnbOpenBtn = document.querySelectorAll('.js-gnb-open'),
		  gnbCloseBtn = document.querySelector('.js-gnb-close'),
		  gnbToggleBtn = document.querySelectorAll('.js_gnb_toggleBtn'),
		  gnbDepth2 = document.querySelectorAll('.depth2');

	if(document.querySelector('.gnb')){
		gnbOpenBtn.forEach(function(el){
			el.addEventListener('click' , function(){
				body.classList.add('ovf');
				$(".js-gnb").show(100, function(){
					$(".js-gnb .gnb__content").stop().animate({"right":"0"}, 450);
				});

				gnbToggleBtn.forEach(function(el){
					let gnbToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js_gnb_toggleBtn'));

					el.addEventListener('click' , function(e){
						if(el.classList.contains('active')){
							el.classList.remove('active');
						}else{
							gnbToggleBtnArray.forEach(function(el){
								el.classList.remove('active');
							});
							el.classList.add('active');
						}
					});
				})

				//gnb depth2 전체보기 하나일 때 col1 class 추가
				gnbDepth2.forEach(function(el){
					let targetLi = el.querySelectorAll('li').length;

					if(targetLi == 1){
						el.classList.add('col1');
					}
				})

				gnbCloseBtn.addEventListener('click' , function(){
					body.classList.remove('ovf');
					$(".js-gnb .gnb__content").stop().animate({"right":"-100%"}, 450);
					setTimeout(function(){
						$(".js-gnb").hide();
					}, 450);
				});
			});
		})
	}

	//header nav
	if(document.querySelector('.nav')){
        let swiper = new Swiper('.nav', {
            slidesPerView: 'auto',
            spaceBetween: 1,
        });
	}

	//header height
	let contentH = document.querySelector('.content');

	if(document.querySelector('.lnb')){
		let lnbH = document.querySelector('.lnb').offsetHeight;

		contentH.style.marginTop = lnbH + 'px';
	}else if(document.querySelector('.header--main')){
		let headerH = document.getElementById('header').offsetHeight;

		contentH.style.marginTop = headerH + 'px';
	}

	// 비밀번호 보기
	const hiddenShow = document.querySelectorAll('.js_hiddenShow');
	class hiddenShowBox {
		constructor(target) {
			this.target = target;
			this.hiddenShowBtn = this.target.querySelector('.hidden-show__btn');
			this.hiddenShowIp = this.target.querySelector(".hidden-show__input");
		}

		hiddenShowFn() {
			const _this = this;
			
			this.hiddenShowBtn.addEventListener("click" , function(){
				if(_this.hiddenShowIp.type === 'password'){
					_this.hiddenShowIp.type = 'text';
					_this.hiddenShowBtn.classList.add('on');
				}else{
					_this.hiddenShowIp.type = 'password';
					_this.hiddenShowBtn.classList.remove('on');
				}
			})
		}
	}    
	hiddenShow.forEach(el => {        
		new hiddenShowBox(el).hiddenShowFn();
	});

	// 툴팁
	const tooltip = document.querySelectorAll('.js-tooltip');
	class tooltipBox {
		constructor(target) {
			this.target = target;
			this.tooltipBtn = this.target.querySelector('.tooltip__button');
			this.tooltipCon = this.target.querySelector(".tooltip__content");
		}

		tooltipFn() {
			const _this = this;
			
			this.tooltipBtn.addEventListener("click" , function(){
				if(_this.tooltipCon.classList.contains('active')){
					_this.tooltipCon.classList.remove('active');
				}else{
					_this.tooltipCon.classList.add('active');
				}
			})
		}
	}
	tooltip.forEach(el => {        
		new tooltipBox(el).tooltipFn();
	});

	//datepicker
	if(document.querySelector('.datepicker')){
		$(".datepicker input").datepicker({
			dateFormat: 'yy-mm-dd',
			showOtherMonths: true,
			prevText: '이전 달',
			nextText: '다음 달',
			monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
			dayNames: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
			dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
			showMonthAfterYear: true,
			yearSuffix: '',
			firstDay:1
		});
	}

	// footer - floating 상단으로
	if(document.querySelector('.top-move')){
		const topMove = document.querySelector('.top-move');

		window.addEventListener('scroll' , ()=>{
			if(window.pageYOffset >= topMove.clientHeight){
				topMove.classList.add('scroll');
			} else {
				topMove.classList.remove('scroll');
			}
		})
	}
});
